import { useMemo } from 'react';

const CustomToolTip = ({
    active,
    payload,
    isIndicatorTypeProc,
    selectedKeys
}: {
    active?: boolean;
    payload?: any[];
    isIndicatorTypeProc?: boolean;
    selectedKeys?: string[];
}) => {
    const tooltipContent = useMemo(() => {
        if (!active || !payload || !payload.length) return null;

        const data = payload[0].payload;
        const normalize = (str: string) => str.toLowerCase().replace(/\s+/g, ' ').trim();
        const normalizedSelectedKeys = selectedKeys?.map(normalize) ?? [];

        const entries = Object.entries(data).filter(([key]) => {
            if (key === 'name') return false;
            if (isIndicatorTypeProc && normalizedSelectedKeys.length) {
                return normalizedSelectedKeys.includes(normalize(key));
            }
            return true;
        });

        return (
            <div className="custom-tooltip bg-primary-100 border border-[#CCCCCC] p-2 text-bmedium rounded-md shadow-md max-w-[275px] sm:min-w-[300px] whitespace-normal break-words text-[13px] z-50">
                <p className="font-bold text-center mb-1">Datos del año {data.name}</p>
                {entries.map(([key, value]) => (
                    <p key={key}>{`${key}: ${Number(value).toLocaleString('es-ES')}`}</p>
                ))}
            </div>
        );
    }, [active, payload, isIndicatorTypeProc, selectedKeys]);

    return tooltipContent;
};

export default CustomToolTip;